import PropTypes from "prop-types";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import * as SavedReportConstants from "../../../constants/SavedReportConstants";
import * as RouteConstants from "../../../constants/RouteConstants";
import {
  describeSendResult,
  formatDateTime,
  sendReason,
} from "../../../helpers/ScheduleSummary";

export const formatFileSize = (bytes) => {
  if (bytes === null || bytes === undefined) {
    return "";
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const TRIGGER_MESSAGES = {
  [SavedReportConstants.REPORT_SEND_TRIGGER_SCHEDULED]:
    "saved_report_trigger_scheduled",
  [SavedReportConstants.REPORT_SEND_TRIGGER_SEND_NOW]:
    "saved_report_trigger_send_now",
};

const DELIVERY_MESSAGES = {
  [SavedReportConstants.REPORT_DELIVERY_ATTACHMENT]:
    "saved_report_delivery_attachment",
  [SavedReportConstants.REPORT_DELIVERY_LINK]: "saved_report_delivery_link",
};

const SendHistoryDialog = ({ visible, reportName = "", history, onHide }) => {
  const intl = useIntl();
  const message = (id) => (id ? intl.formatMessage({ id }) : "");

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={intl.formatMessage(
        { id: "saved_report_history_title" },
        { name: reportName }
      )}
      style={{ width: "60rem" }}
      breakpoints={{ "960px": "95vw" }}
    >
      <DataTable
        value={history || []}
        loading={history === null}
        dataKey="id"
        size="small"
        stripedRows
        emptyMessage={message("saved_report_history_empty")}
      >
        <Column
          header={message("saved_report_history_time")}
          body={(row) => formatDateTime(row.startedAtUtc, intl)}
        />
        <Column
          header={message("saved_report_history_trigger")}
          body={(row) => message(TRIGGER_MESSAGES[row.trigger])}
        />
        <Column
          header={message("saved_report_history_result")}
          body={(row) => (
            <div>
              <div>{describeSendResult(row, intl)}</div>
              {(sendReason(row) && <small>{sendReason(row)}</small>) || null}
            </div>
          )}
        />
        <Column
          header={message("saved_report_history_delivery")}
          body={(row) => (
            <div>
              <div>{message(DELIVERY_MESSAGES[row.delivery])}</div>
              {(row.fileAvailable && (
                <Link
                  to={`${RouteConstants.APP_ROUTE_REPORT_DOWNLOADS}/${row.id}`}
                >
                  {message("saved_report_download")}
                </Link>
              )) ||
                null}
            </div>
          )}
        />
        <Column
          header={message("saved_report_history_size")}
          body={(row) => formatFileSize(row.fileSize)}
        />
        <Column
          header={message("saved_report_history_rows")}
          body={(row) => (row.rowCount ?? "")}
        />
      </DataTable>
    </Dialog>
  );
};

SendHistoryDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  reportName: PropTypes.string,
  history: PropTypes.array,
  onHide: PropTypes.func.isRequired,
};

export default SendHistoryDialog;
